// extracted by mini-css-extract-plugin
export default {"error":"ErrorMessage_error__nFWU9"};